import RowContainer from './RowContainer';

import { colors } from '../../constants/styleConstants';

const HeaderRowContainer = RowContainer.extend`
  background-color: ${colors.white};
  border-bottom: solid .1rem ${colors.grey};
  font-weight: 600;
  padding-bottom: 1rem;
`;

export default HeaderRowContainer;



// WEBPACK FOOTER //
// ./src/components/common/HeaderRowContainer.js